import { Draggable, Droppable } from "react-beautiful-dnd";
import { colorTheme } from "../ColorTheme";
import { DeleteIcon, SettingsIcon, DownArrow, DragIcon, UpArrow, DividerIcon, ContentBlockIcon, EditIcon, XIcon } from "assests/GmsIcons";
import UIConnectorItem from "./UIConnectorItem";
import UICategoryItem from "./UICategoryItem";
import UIFieldItem from "./UIFieldItem";
import React, { useEffect, useState } from "react";
import {EXCLUSION_DEFAULT, INCLUSION_DEFAULT, MULTI_CHOICE_EXCLUDED_DEFAULT} from "../../../ISRConstants";
import TrixTextEditor from "Pages/GMS/ISR/Components/TrixTextEditor";
import AppSettings from "Settings/AppSettings";

const UIDefinition = ({submodel, modelIndex, updateCategory, updateField, updateConnector, deleteField, deleteDataModel, dragHandleProps, 
                        setEditFlag, setEditField, setSubmodelEditFlag, setEditSubmodel, setCategoryEditFlag, setEditCategory, projectId}: any) => {
    const droppableIdentifier = React.useMemo(() => {
        return `form_items-${submodel.smid}`; 
    }, [submodel.smid]);

    const [uiDefinition, setUiDefinition] = useState<any[]>([]);
    const [collapse, setCollapse] = useState(false);

    const handleCollapse = () => {
        setCollapse((prev) => prev = !prev);
    }

    const formateContent = (content: string) => {
        if (!content) return 'No content found ...';
        
        const txt = document.createElement('textarea');
        txt.innerHTML = content;
        const decodedContent = txt.value;
        
        const cleanContent = decodedContent
            .replace(/<[^>]*>/g, '')
            .replace(/<!--[\s\S]*?-->/g, '');
        
        return cleanContent.substring(0, 20) + '...';
    };

    useEffect(() => {
        let definitionList: any[] = [];
        if (submodel?.items?.length > 0) {
            submodel.items.forEach((field: any, index: any) => {
            if (!field) return;  
                try{
                if (!field.type) {
                    if (field.connectorName !== undefined) {
                        field.type = "Connector";
                    } else if (field.categoryName !== undefined) {
                        field.type = "Category";
                    } else if (field.fieldName !== undefined) {
                        field.type = "Field";
                    }
                }

                const categorySelectionLabel = field?.categorySelectionLabel === undefined 
                    ? `Select ${field?.data?.name}` 
                    : field?.categorySelectionLabel;
                    
                    if(field.type === "Category") {
                        let type: any = {
                            id: field.id ?? '',
                            rank: index + 1,
                            categoryName: field?.data?.name ?? '',
                            productLabel: field?.productLabel ?? 'Add to cart',
                            groupLabel: field?.groupLabel ?? '',
                            isCategoryVisible: field?.isCategoryVisible ?? true,
                            inclusion: field?.inclusion ?? INCLUSION_DEFAULT,
                            exclusion: field?.exclusion ?? EXCLUSION_DEFAULT,
                            categorySelectionLabel: categorySelectionLabel,
                            hideWhenNoProductsAvailable: field?.hideWhenNoProductsAvailable,
                            thumbnail: field?.thumbnail,
                            imageDisplay: field?.imageDisplay,
                            sortConfig: field?.sortConfig,
                        }
                        definitionList.push(
                            <Draggable key={`${field?.id}`} draggableId={`${field?.id}`} index={index}>
                                {(provided, snapshot) => (
                                    <li ref={provided.innerRef} {...provided.draggableProps} style={getItemStyle(
                                                                                snapshot.isDragging,
                                                                                provided.draggableProps.style
                                                                            )}>
                                        <UICategoryItem key={type?.id + index} category={type} updateCategory={updateCategory} categoryIndex={index} modelIndex={modelIndex} dragHandleProps = {provided.dragHandleProps} setCategoryEditFlag={setCategoryEditFlag} setEditCategory={setEditCategory}/>
                                    </li>
                                )}
                            </Draggable>
                        )
                    }
                    else if(field.type === "Connector"){
                        let type: any = {
                            id: field?.id ?? '',
                            rank: index + 1,
                            connectorName: field?.data?.name ?? '',
                            isConnectorVisible: field?.isConnectorVisible ?? true,
                        }
                        definitionList.push(
                            <Draggable key={`${field?.id}`} draggableId={`${field?.id}`} index={index}>
                                {(provided, snapshot) => (
                                    <li ref={provided.innerRef} {...provided.draggableProps} style={getItemStyle(
                                                                                snapshot.isDragging,
                                                                                provided.draggableProps.style
                                                                            )}>
                                        <UIConnectorItem key={type?.id + index} connector={type} updateConnector={updateConnector} connectorIndex={index} dragHandleProps = {provided.dragHandleProps}/>
                                    </li>
                                )}
                            </Draggable>
                        )
                    } else if (field.type === "content-block") {
                        definitionList.push(
                            <Draggable key={field?.id || `widget-content-block-${index}`}  draggableId={`widget-${field?.id || Date.now()}`}  index={index}>
                                {(provided, snapshot) => (
                                    <li ref={provided.innerRef} {...provided.draggableProps} style={getItemStyle(
                                        snapshot.isDragging,
                                        provided.draggableProps.style
                                    )}>
                                        <div className="tw-w-full tw-h-auto tw-bg-white tw-rounded tw-shadow tw-border tw-border-[#dadbdd] tw-py-1 tw-px-3 tw-mt-2">
                                            <div className="tw-flex tw-items-center tw-justify-between">
                                                <div className="tw-flex tw-items-center tw-gap-3">
                                                    <div {...provided.dragHandleProps}>
                                                        <DragIcon />
                                                    </div>
                                                    <div className="tw-flex tw-items-center tw-gap-2">
                                                        <ContentBlockIcon />
                                                        <span className="tw-text-[#172B4D] tw-text-sm">Content Block</span>
                                                    </div>
                                                </div>
                                                <div className="tw-flex tw-items-center tw-gap-4">
                                                    <div className="tw-w-auto tw-h-9 tw-px-2.5 tw-py-2 bg-[#f4f5f7] tw-rounded tw-border tw-border-[#ebecf0] tw-justify-start tw-items-center tw-gap-2.5 tw-inline-flex">
                                                        <div className="tw-text-[#172b4d] tw-text-sm">
                                                            {formateContent(field.content)}  
                                                        </div>
                                                    </div>
                                                    <button onClick={() => {
                                                        const updatedField = {
                                                            ...field,
                                                            isEditing: !field.isEditing 
                                                        };
                                                        updateField(updatedField, index, modelIndex);
                                                    }}>
                                                        {field?.isEditing ? <XIcon /> :<EditIcon />}
                                                    </button>
                                                    <button onClick={() => deleteField(index, modelIndex)}>
                                                        <DeleteIcon />
                                                    </button>
                                                </div>
                                            </div>
                                            {field.isEditing && (
                                                <div className='tw-items-center tw-border-t tw-border-[#dadbdd] tw-mt-2.5 tw-pt-3'>
                                                    <TrixTextEditor
                                                        id={'ui-definition-content-block'} 
                                                        updateInfo={(content) => {
                                                            const updatedField = { ...field, content: content };
                                                            updateField(updatedField, index, modelIndex);
                                                        }} 
                                                        value={field.content || ''} 
                                                        selectedItemId={projectId} 
                                                        attachmentUrl={`${AppSettings.GMS_BACKEND_API_URL}/isr/models/${projectId ?? ''}/image/upload`}
                                                    />
                                                    
                                                </div>
                                            )}
        
                                        </div>
                                    </li>
                                )}
                            </Draggable>
                        )
                    }
                    else if (field.type === "divider") {
                        definitionList.push(
                            <Draggable key={field?.id || `widget-divider-${index}`}  draggableId={`widget-${field?.id || Date.now()}`}  index={index}>
                                {(provided, snapshot) => (
                                    <li ref={provided.innerRef} {...provided.draggableProps} style={getItemStyle(
                                        snapshot.isDragging,
                                        provided.draggableProps.style
                                    )}>
                                        <div className="tw-w-full tw-h-auto tw-bg-white tw-rounded tw-shadow tw-border tw-border-[#dadbdd] tw-py-2.5 tw-px-3 tw-mt-2">
                                            <div className="tw-flex tw-items-center tw-justify-between">
                                                <div className="tw-flex tw-items-center tw-gap-3">
                                                    <div {...provided.dragHandleProps}>
                                                        <DragIcon />
                                                    </div>
                                                    <div className="tw-flex tw-items-center tw-gap-2">
                                                        <DividerIcon />
                                                        <span className="tw-text-[#172B4D] tw-text-sm">Divider</span>
                                                    </div>
                                                </div>
                                                <button onClick={() => deleteField(index, modelIndex)}>
                                                    <DeleteIcon />
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                )}
                            </Draggable>
                        )
                    }
                    else {
                        let type: any = {
                            id: field?.id ?? '',
                            rank: index + 1,
                            fieldType: field?.fieldType ?? '',
                            modelFieldType: field?.type ?? '',
                            fieldName: field?.name ?? '',
                            enableCondition: false,
                            isFieldVisible: field?.isFieldVisible ?? true,
                            conditionState: '',
                            fieldTargetSelection: '',
                            answerTargetSelection: '',
                            fieldExclusion: field?.fieldExclusion ?? EXCLUSION_DEFAULT,
                            fieldInclusion: field?.fieldInclusion ?? INCLUSION_DEFAULT,
                            multiChoicefieldExcludedOption: field?.multiChoicefieldExcludedOption ?? MULTI_CHOICE_EXCLUDED_DEFAULT,
                            groupLabel: field?.groupLabel ?? '',
                            displayName: field?.displayName ?? field?.fieldName ?? '',
                            imageSize: field?.imageSize,
                            imageDisplay: field?.imageDisplay,
                            captionAlignment: field?.captionAlignment,
                            layoutStyle: field?.layoutStyle,
                            placement: field?.placement,
                            loadMoreShowAll: field?.loadMoreShowAll,
                            loadMoreInitialLoadCount: field?.loadMoreInitialLoadCount,
                            loadMoreButtonName: field?.loadMoreButtonName,
                            loadMoreShowAllRemaining: field?.loadMoreShowAllRemaining,
                            loadMoreBatchCount: field?.loadMoreBatchCount,
                            showLessButtonName: field?.showLessButtonName,
                        }
                        definitionList.push(
                            <Draggable key={`${field?.id}`} draggableId={`${field?.id}`} index={index}>
                                {(provided, snapshot) => (
                                    <li ref={provided.innerRef} {...provided.draggableProps} style={getItemStyle(
                                                                                snapshot.isDragging,
                                                                                provided.draggableProps.style
                                                                            )}>
                                        <UIFieldItem key={type?.id + index} field={type} fieldIndex={index} deleteField={deleteField} updateField={updateField} modelIndex={modelIndex} dragHandleProps = {provided.dragHandleProps} setEditFlag={setEditFlag} setEditField={setEditField}/>
                                    </li>
                                )}
                            </Draggable>
                        )
                    }
                }
                catch(e){
                    console.log(e)
                }
    
            })
        }
        setUiDefinition(definitionList)

    }, [submodel])
    
    
    return (
    <>
        <div className="tw-w-full tw-h-auto tw-bg-shades-of-grey-10 tw-rounded tw-shadow tw-border tw-border-[#dadbdd] tw-mt-4" >
            <div className="tw-flex tw-items-center tw-justify-between tw-px-3 tw-w-full tw-h-[38px] tw-bg-white tw-rounded-tl tw-rounded-tr " >
                <div className="tw-flex tw-items-center tw-gap-3">
                    <div {...dragHandleProps}>
                        <DragIcon />
                    </div>
                    <label className="tw-text-[#090A42] tw-text-sm tw-ml-4">{submodel?.name ?? ''}</label>
                </div>
                <div className="tw-flex tw-items-center tw-gap-3">
                    <button onClick={() => {
                            setEditSubmodel({modelIndex: modelIndex, submodel: submodel})
                            setSubmodelEditFlag(true)
                        }}>
                        <SettingsIcon />
                    </button>
                    <button onClick={() => {
                        deleteDataModel(modelIndex)
                    }}>
                        <DeleteIcon />
                    </button>
                    <button onClick={(e) => { e.stopPropagation(); handleCollapse(); }} className='tw-rounded tw-bg-gainsboro-100 tw-w-6 tw-h-6 tw-flex tw-flex-col tw-items-center tw-justify-center'>
                            {!collapse ? <UpArrow /> : <DownArrow />}
                    </button>
                </div>
            </div>
            {!collapse ? <div className='tw-mx-2 tw-my-2'>
                <Droppable droppableId={droppableIdentifier} type="form_items" >
                    {(provided, snapshot) => (
                        <ul style={{
                                backgroundColor: colorTheme.background,
                                //border: 'dotted',
                                width: '100%',
                                overflow: 'auto',
                                marginTop: '0px',
                                background: snapshot.isDraggingOver ? "lightblue" : "white",
                            }}
                            {...provided.droppableProps} ref={provided.innerRef}
                        >
                            {uiDefinition}
                            {provided.placeholder}
                        </ul>
                    )}
                </Droppable>
            </div>:null}
        </div>
    </>
    );
}

const getItemStyle = (isDragging: any, draggableStyle: any) => ({
    userSelect: "none",
    foreGround: isDragging ? "lightblue" : "white",
    ...draggableStyle
});

export default UIDefinition;